import React from "react"
import styled from "@emotion/styled"

const Footer = ({ children }) => <StyledFooter>{children}</StyledFooter>

export default Footer

const StyledFooter = styled.footer`
  background-color: var(--theme-ui-colors-snopp-kula);
  color: var(--theme-ui-colors-text);
  padding: 20px 5px;
  margin-top: auto;
`
